import Vue from 'vue'
import HeaderNavLink from '../components/Layout/HeaderNavLink'
export default Vue.extend({
  props: {
      megaMenuFullWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      ctaText: {
        type: String,
        required: true
      },
      hasCta: {
        type: Boolean,
        required: true
      },
      megaMenuTitleClasses: {
        type: [String, Array],
        required: true,
      },
      megaMenuTitleStyles: {
        type: [String, Object],
        required: true,
      },
      megaMenuClasses: {
        type: [String, Array],
        required: true,
      },
      megaMenuStyles: {
        type: [String, Object],
        required: true,
      },
      megaMenuContainerClasses: {
        type: [String, Array],
        required: true,
      },
      megaMenuContainerStyles: {
        type: [String, Object],
        required: true,
      },
      subMenuContainerClasses: {
        type: [String, Array],
        required: true,
      },
      subMenuContainerStyles: {
        type: [String, Object],
        required: true,
      },
      subMenuClasses: {
        type: [String, Array],
        required: true,
      },
      subMenuStyles: {
        type: [String, Object],
        required: true,
      },
      ctaClasses: {
        type: [String, Array],
        required: true,
      },
      ctaStyles: {
        type: [String, Object],
        required: true,
      },
      containerNavLinkClasses: {
        type: [String, Array],
        required: true,
      },
      navLinkClasses: {
        type: [String, Array],
        required: true,
      },
      navLinkStyles: {
        type: [String, Object],
        required: true,
      },
      classes: {
        type: Array,
        required: true,
      },
      logo: {
        type: String,
        required: true,
      },
      navLinks: {
        type: Array,
        required: true,
      }
    },
    components: {HeaderNavLink}
})